/** Hasta cuándo se muestra el aviso del cambio de inicio de sesión (00:00 de Argentina del 15/11/2026). */
export const AVISO_LOGIN_HASTA = new Date("2026-11-15T03:00:00Z");

/** El aviso es para quien entra por Cognito, las primeras semanas después del cambio. */
export const mostrarAvisoNuevoLogin = (provider: string | undefined, hoy: Date = new Date()): boolean =>
  provider === "cognito" && hoy < AVISO_LOGIN_HASTA;
